// extracted by mini-css-extract-plugin
module.exports = {"burgerMenu":"Xyy31XWgV5G9S-eplhrdh","active":"_3ZOPLwzusA_ijSO_7xDtIY","white":"vQiqhEH-X5HrEQL2UNY6O","purple":"_1E2NmuUoqauWDvV_y-QU1l"};